import {Component, Input, OnInit, inject} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    imports: [TranslateModule]
})
export class ConfirmComponent implements OnInit {

  @Input() title: string;
  @Input() body: string;
  modal = inject(NgbActiveModal);

  ngOnInit() {
  }

}
